// extracted by mini-css-extract-plugin
var _1 = "src-components-automation-Process-module__activity";
var _2 = "src-components-automation-Process-module__cancelled";
var _3 = "src-components-automation-Process-module__completed";
var _4 = "src-components-automation-Process-module__failed";
var _5 = "src-components-automation-Process-module__pending";
var _6 = "src-components-automation-Process-module__process";
var _7 = "src-components-automation-Process-module__running";
export { _1 as "activity", _2 as "cancelled", _3 as "completed", _4 as "failed", _5 as "pending", _6 as "process", _7 as "running" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"activity\":\"src-components-automation-Process-module__activity\",\"cancelled\":\"src-components-automation-Process-module__cancelled\",\"completed\":\"src-components-automation-Process-module__completed\",\"failed\":\"src-components-automation-Process-module__failed\",\"pending\":\"src-components-automation-Process-module__pending\",\"process\":\"src-components-automation-Process-module__process\",\"running\":\"src-components-automation-Process-module__running\"}";
        // 1771440568705
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  